import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const useHyroTimerPicker = ({
  value,
  onChange,
  isRangePersistent = true,
  fromKeyword = "from",
  toKeyword = "to",
  timeConstraints
}) => {
  const { [fromKeyword]: startTime, [toKeyword]: endTime } = value || {};

  const handleFromChange = (newTime) => {
    const newStartTime = dayjs(newTime, "HH:mm");
    if (startTime && endTime && isRangePersistent) {
      const prevStart = dayjs(startTime, "HH:mm");
      const prevEnd = dayjs(endTime, "HH:mm");
      const duration = prevEnd.diff(prevStart, "minute");
      let newEndTime = newStartTime ? newStartTime.add(duration, "minute") : endTime;

      if (timeConstraints?.to?.max) {
        const maxEndTime = dayjs(timeConstraints.to.max, "HH:mm");
        if (newEndTime.isAfter(maxEndTime, "minute")) {
          newEndTime = maxEndTime;
        }
      }

      onChange({ [fromKeyword]: newStartTime.format("HH:mm"), [toKeyword]: newEndTime.format("HH:mm") });
    } else {
      onChange({ [fromKeyword]: newStartTime.format("HH:mm"), [toKeyword]: endTime });
    }
  };

  const handleToChange = (newEndTime) => {
    onChange({ [fromKeyword]: startTime, [toKeyword]: newEndTime });
  };

  const getEndTimeConstraints = () => {
    if (!isRangePersistent || !startTime || !timeConstraints?.to) {
      return timeConstraints?.to;
    }
    const originalMax = timeConstraints.to.max ? dayjs(timeConstraints.to.max, "HH:mm") : null;
    if (originalMax) {
      return {
        ...timeConstraints.to,
        max: originalMax.format("HH:mm")
      };
    }

    return timeConstraints.to;
  };

  return {
    startTime,
    endTime,
    handleFromChange,
    handleToChange,
    getEndTimeConstraints
  };
};

export default useHyroTimerPicker;
